import { Api } from './constants';
import { pipePromise, handleStatuses } from 'utils';

export const fetchInfluencers = pipePromise(
  (datasetName, options) => {
    const { pageSize, pageNumber, token, publisherId } = options;

    return fetch(Api.GetDatasetsByName(datasetName, pageSize, pageNumber), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
    });
  },
  handleStatuses(),
  (response) => response.json()
);

export const createInfluencer = pipePromise(
  (token, key, publisherId, data) =>
    fetch(Api.CreateDataset('influencer'), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
      body: JSON.stringify({
        Key: key,
        Data: data,
      }),
    }),
  handleStatuses(),
  (response) => response.text()
);

export const deleteInfluencer = pipePromise(
  (id, options) => {
    const { token, publisherId } = options;

    return fetch(Api.DeleteDataset(id), {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
    });
  },
  handleStatuses(),
);
